export { ProductCard } from './ProductCard';
export { createNameExtractor, formatPrice, normalizeLabels, decodeHtmlEntities } from './utils';
export type {
  ProductCardProps,
  ProductCardItem,
  CurrencyConfig,
  FavoriteManager,
  FavoriteData,
  FavoriteDataExtractor,
  NameExtractor,
  NameMapping,
  NormalizedLabel,
} from './types';

